/**
 * CtaButtonForm: edit form for the `cta-button` block.
 *
 * data: { text, link, variant? }
 *
 * Text inputs for the label and link, and a select for the Bootstrap button
 * variant (CTA_BUTTON_VARIANTS: mirrors the renderer's ALLOWED_VARIANTS).
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col } from 'react-bootstrap';

import { CTA_BUTTON_VARIANTS } from '../blockTypes';

export default function CtaButtonForm({ data, onChange }) {
    const d = data || {};

    const update = (field, value) => {
        onChange({ ...d, [field]: value });
    };

    return (
        <>
            <Row>
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="cta-text">
                        <Form.Label>Button Text</Form.Label>
                        <Form.Control
                            type="text"
                            value={d.text || ''}
                            onChange={(e) => update('text', e.target.value)}
                            placeholder="Learn more"
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="cta-link">
                        <Form.Label>Button Link</Form.Label>
                        <Form.Control
                            type="text"
                            value={d.link || ''}
                            onChange={(e) => update('link', e.target.value)}
                            placeholder="/directory or https://…"
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Form.Group className="mb-3" controlId="cta-variant">
                <Form.Label>Button Style</Form.Label>
                <Form.Select
                    value={d.variant || 'primary'}
                    onChange={(e) => update('variant', e.target.value)}
                >
                    {CTA_BUTTON_VARIANTS.map((variant) => (
                        <option key={variant} value={variant}>
                            {variant}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>
            <Form.Text muted>
                The button only renders on the page when both its text and link
                are set.
            </Form.Text>
        </>
    );
}

CtaButtonForm.propTypes = {
    data: PropTypes.object,
    onChange: PropTypes.func.isRequired,
};

CtaButtonForm.defaultProps = {
    data: {},
};
